import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PizzaIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="m1.232 12.634-.016-.016.002.002.004.004.01.01a2.257 2.257 0 0 0 .126.12c.08.072.195.17.342.284a8.39 8.39 0 0 0 1.284.813C4.112 14.434 5.773 15 7.957 15c2.14 0 3.67-.416 4.76-.942a6.606 6.606 0 0 0 1.982-1.441l.213-.222a.32.32 0 0 0 0-.44l-.995-1.03a.295.295 0 0 0-.428.002l-.216.224c-.219.227-.624.646-1.406 1.023-.794.384-2.029.747-3.91.747-1.837 0-3.192-.473-4.074-.93a6.39 6.39 0 0 1-.977-.616 3.875 3.875 0 0 1-.27-.228l-.004-.004-.026-.04a.295.295 0 0 0-.426-.071l-1.057.806a.318.318 0 0 0-.093.387l.185.392.017.017Z"
		></path>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="M3.095 9.966a7.025 7.025 0 0 0 4.862 1.916 7.025 7.025 0 0 0 4.862-1.916.308.308 0 0 0 .054-.368l-4.477-8.33a.495.495 0 0 0-.878 0L3.04 9.597a.308.308 0 0 0 .054.368Zm2.852-.163c.555 0 1.005-.465 1.005-1.039 0-.574-.45-1.04-1.005-1.04-.556 0-1.006.466-1.006 1.04 0 .574.45 1.04 1.006 1.04Zm5.026-1.039c0 .574-.45 1.04-1.005 1.04-.556 0-1.006-.466-1.006-1.04 0-.574.45-1.04 1.006-1.04.555 0 1.005.466 1.005 1.04ZM7.957 6.685c.555 0 1.005-.465 1.005-1.039 0-.574-.45-1.04-1.005-1.04-.555 0-1.005.466-1.005 1.04 0 .574.45 1.04 1.005 1.04Z"
		></path>
	</svg>
))
